import { useCallback, useMemo, useState } from 'react';

/** Selection state for "select all / delete selected" on listing pages. */
export function useBulkSelect() {
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const isSelected = useCallback((id: string) => selected.has(id), [selected]);

  const toggle = useCallback((id: string) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const setAll = useCallback((ids: string[], checked: boolean) => {
    setSelected(checked ? new Set(ids) : new Set());
  }, []);

  const clear = useCallback(() => setSelected(new Set()), []);

  return useMemo(
    () => ({ selected, isSelected, toggle, setAll, clear, count: selected.size }),
    [selected, isSelected, toggle, setAll, clear],
  );
}

export type BulkSelect = ReturnType<typeof useBulkSelect>;
